<template>
  <PageSecondary>
    <template #title>Менторство и партнёрство</template>
    <p>
      Я могу стать ментором для вас лично или для вашего проекта или компании. Спустя время - инвестировать и стать партнёром.
    </p>
    <p>
    У тебя есть цель, идея или уже есть компания, это значит, что ты творческий и свободный человек,
    это очень здорово! Чтобы начать диалог, напиши мне:
    </p>
    <ul>
      <li>Суть в 1 предложении.</li>
      <li>Твоя личная мотивация "поднять денег", "сделать добро".</li>
      <li>Сколько часов в неделю ты готов уделять работе.</li>
      <li>Чем ты будешь заниматься и чем не можешь заниматься.</li>
    </ul>
    в <TextMe /> и обсудим ;)
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import TextMe from "@/components/components/TextMe";
export default {
name: "WannaStartup",
  components: {TextMe, PageSecondary}
}
</script>

<style scoped>

</style>
